import { render } from "./PastEvents.vue?vue&type=template&id=c5889e7e&scoped=true"
import script from "./PastEvents.vue?vue&type=script&lang=js"
export * from "./PastEvents.vue?vue&type=script&lang=js"

import "./PastEvents.vue?vue&type=style&index=0&id=c5889e7e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5889e7e"]])

export default __exports__